<div class="st-media-fullscreen-container">
    <st-media
        maxWidth="1592"
        maxHeight="880"
        class="st-media-fullscreen-item"
        [mediaUrl]="currentMediaUrl()"
        [mediaType]="mediaType()" />
    <div class="st-media-fullscreen-image-info">
        <div class="st-media-fullscreen-image-info__name">
            <div>
                {{ languageSettings.PSTWebWireAttachmentsMediaName }}
            </div>
            <label>{{ getImageName() }}</label>
        </div>
        <div class="st-media-fullscreen-image-info__type">
            <div>
                {{ languageSettings.PSTWebWireAttachmentsMediaType }}
            </div>
            <div>
                {{ mediaExtensionType() }}
            </div>
        </div>
    </div>
</div>
<div class="st-media-fullscreen-paginator">
    <button
        mat-icon-button
        (click)="navigate(NavigationDirection.FIRST, currentMediaUrl())">
        <mat-icon>first_page</mat-icon>
    </button>
    <button
        mat-icon-button
        (click)="navigate(NavigationDirection.PREVIOUS, currentMediaUrl())">
        <mat-icon>navigate_before</mat-icon>
    </button>
    <span class="st-media-fullscreen-paginator__text">{{ currentMediaUrlIndex() }} of {{ mediaTotalCount() }}</span>
    <button
        mat-icon-button
        (click)="navigate(NavigationDirection.NEXT, currentMediaUrl())">
        <mat-icon>navigate_next</mat-icon>
    </button>
    <button
        mat-icon-button
        (click)="navigate(NavigationDirection.LAST, currentMediaUrl())">
        <mat-icon>last_page</mat-icon>
    </button>
    <button
        class="st-media-fullscreen-paginator__button"
        (click)="closeImageDialog()">
        {{ languageSettings.PSTWebWireAttachmentsExitMediaMode }}
    </button>
</div>
